import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../httpService/httpService";

export const fetchConsolidatedSummary = createAsyncThunk(
  "/fetchConsolidatedSummary",
  async ( plan_id , { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axiosInstance.get(`/fetch-plan-summary-consolidated/client-appsells/${plan_id}`, {
        
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.data || response.status !== 200) {
        throw new Error("Failed to fetch consolidated plan summary");
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.message || "An error occurred while fetching consolidated plan summary"
      );
    }
  }
);

const fetchConsolidatedSummarySlice = createSlice({
  name: "fetchConsolidatedSummary",
  initialState: {
    plan1: {},
    plan2: {},
    status: "idle",
    error: null,
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchConsolidatedSummary.pending, (state) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(fetchConsolidatedSummary.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.plan1 = action.payload.consolidated_ooh_plan_summary;
        state.plan2 = action.payload.plan_medium_summary;
        state.loading = false;
      })
      .addCase(fetchConsolidatedSummary.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export default fetchConsolidatedSummarySlice.reducer;
